import React from 'react';

import { string } from 'prop-types';

// Import icons
import {
	IconFacebook,
	IconGoogle,
	IconApple,
	IconPhone
} from 'components/views/authentication/login/firebase_auth/style';

const AuthMethodIcon = ({ method, isOperator }) => {
	switch (method) {
		case 'facebook':
			return <IconFacebook />;

		case 'google':
			return <IconGoogle />;

		case 'phone':
			return <IconPhone />;

		case 'apple':
			return <IconApple operator={isOperator} />;

		default:
			return null;
	}
};

AuthMethodIcon.propTypes = { method: string.isRequired };

export default AuthMethodIcon;
